import React from 'react'
import styled from 'styled-components'
import { INVESTOR_NOTICE, SAMSUNG_NOTICE } from '@constants/notice'

const Section = styled.section`
  background-color: #dcdeeb;
  width: 100%;
  padding: 32px 24px;
`
const MaxWidthView = styled.div`
  max-width: 500px;
  margin: 0 auto;
`
const Title = styled.p`
  font-family: Pretendard700, sans-serif;
  color: #19191b;
  opacity: 0.8;
  line-height: 120%;
  font-size: 12px;
  margin-bottom: 8px;
`

const Desc = styled.p`
  font-family: Pretendard400, sans-serif;
  font-size: 12px;
  line-height: 120%;
  color: #555564;
  opacity: 0.8;
  margin-bottom: 8px;
`
const List = styled.ul`
  margin-bottom: 12px;
`
const Item = styled.li`
  font-family: Pretendard400, sans-serif;
  font-size: 12px;
  line-height: 120%;
  color: #555564;
  opacity: 0.8;
`
const FlexBox = styled.div`
  display: flex;
  gap: 4px;
`
const Caption = styled.div`
  display: flex;
  flex-direction: column;
  color: #555564;
  letter-spacing: -0.24px;
  opacity: 0.8;
  font-size: 12px;
  line-height: 120%;
  font-family: Pretendard700, sans-serif;
  gap: 4px;
`

const SamsungNoticeBox = () => {
  return (
    <Section>
      <MaxWidthView>
        <Title>꼭! 확인해 주세요.</Title>
        <List>
          {SAMSUNG_NOTICE.map((text, index) => (
            <FlexBox key={index}>
              <Item>•</Item>
              <Item>{text}</Item>
            </FlexBox>
          ))}
        </List>
        <Desc>
          [소득세법]제21조(기타소득), 제127조(원천징수 의무),
          제164조(지급명세서의 제출)에 따라 제세공과금 납무 및 지급명세서 제출을
          위해 당첨자의 주민등록번호를 수집 이용할 수 있습니다. 이벤트를 통해
          수집 이용된 개인정보는 혜택 지급을 위한 용도로만 활용되며, 이벤트 종료
          후, 즉시 파기합니다.
        </Desc>
        <Title>투자자 유의사항</Title>
        <List>
          {INVESTOR_NOTICE.map((content, index) => (
            <FlexBox key={index}>
              <Item>•</Item>
              <Item>{content}</Item>
            </FlexBox>
          ))}
        </List>
        <Caption>
          <span>
            * 엠엘투자자문(주)의 내부통제기준에 따라 준법감시 심의를 필함.
          </span>
          <span>&nbsp;・ 엠엘광고준법 2025-제8호</span>
          <span>* 한국금융투자협회 심사필 제25-01670호</span>
          <span>(2025.04.28 - 2026.04.27)</span>
        </Caption>
      </MaxWidthView>
    </Section>
  )
}

export default SamsungNoticeBox
